// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"19351":"a5ce6a92","46832":"c42ece5b"}[chunkId] || chunkId) + "." + {"2254":"58f72c59342e9b51","11417":"21e11424e0420983","18803":"47ad7b9a26536391","19351":"ab7e97a748699ec2","22149":"268355ab6c1781c3","46832":"5a2abdfd83fc2dcd","53348":"b3dafae3a67ee0e4"}[chunkId] + ".js";
};